
<div class="flow-tour">
	<div v-if="inprogress && overlay" class="flow-tour-overlay" @click="handleOverlayClick()" />
	<Step v-if="inprogress" ref="step">
		<div v-html="currentStep.content" />
		<template #footer>
			<div class="display-flex j-c-space-bet align-items-center">
				<p class="paragrapg-1 fc-light">{{ currentStepId }}/{{ steps.length }}</p>
				<div class="display-flex align-items-center flex-gap-12">
					<Button v-if="currentStepId < steps.length" type="default" size="small" @click="done()">
						skip all
					</Button>
					<Button v-if="currentStepId < steps.length" type="primary" size="small" @click="next()">
						next
					</Button>
					<Button
						v-if="currentStepId === steps.length"
						type="success"
						size="small"
						@click="done()"
					>
						done
					</Button>
				</div>
			</div>
		</template>
	</Step>
</div>
